import React from 'react'
import {faCaretLeft, faCaretRight} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"

function ActionButton (props) {
  return (
    <div className={`button ${props.action}`} onClick={props.onClick}>
      <div style={{display: 'flex', justifyContent: 'center'}}>
        {props.children}
      </div>
    </div>
  )
}

export default function ListBoxActions(props) {
  return (
    <div className="list-actions">
      <ActionButton action="right" onClick={props.onRight} >
        <FontAwesomeIcon icon={faCaretRight} />
      </ActionButton>
      <ActionButton action="all-right" onClick={props.onAllRight} >
        <FontAwesomeIcon icon={faCaretRight} />
        <FontAwesomeIcon icon={faCaretRight} />
      </ActionButton>
      <ActionButton action="all-left" onClick={props.onAllLeft} >
        <FontAwesomeIcon icon={faCaretLeft} />
        <FontAwesomeIcon icon={faCaretLeft} />
      </ActionButton>
      <ActionButton action="left" onClick={props.onLeft} >
        <FontAwesomeIcon icon={faCaretLeft} />
      </ActionButton>
    </div>
  )
}
